import * as React from 'react'

function SvgFaqDialog(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3579 1H1.71431C1.26786 1 1 1.35715 1 1.71431V14.1256C1 14.5721 1.35715 14.8399 1.71431 14.8399H14.8399C15.2864 14.8399 15.5542 15.1971 15.5542 15.5542C15.5542 16.0007 15.9114 16.2686 16.2686 16.2686C16.6257 16.2686 16.9829 15.9114 16.9829 15.5542V1.71431C17.0722 1.35715 16.8043 1 16.3579 1ZM9.03609 11.9827C8.58964 11.9827 8.32176 11.6255 8.32176 11.2683C8.32176 10.8219 8.67893 10.554 9.03609 10.554C9.39325 10.554 9.7504 10.9112 9.7504 11.2683C9.7504 11.6255 9.48254 11.9827 9.03609 11.9827ZM10.1076 8.0539C9.83969 8.14319 9.7504 8.41104 9.7504 8.67891C9.7504 9.12536 9.39325 9.39325 9.03609 9.39325C8.67893 9.39325 8.32176 9.03607 8.32176 8.67891C8.32176 7.8753 8.76822 7.16101 9.39325 6.80385C9.66112 6.71456 9.7504 6.44667 9.7504 6.17881C9.7504 5.73236 9.39325 5.4645 9.03609 5.4645C8.67893 5.4645 8.32176 5.82165 8.32176 6.17881C8.32176 6.62526 7.96461 6.89311 7.60745 6.89311C7.25029 6.89311 6.89311 6.53596 6.89311 6.17881C6.89311 5.01804 7.87532 4.03585 9.03609 4.03585C10.1969 4.03585 11.179 5.01804 11.179 6.17881C11.2683 6.89312 10.8219 7.60745 10.1076 8.0539Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgFaqDialog
